var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2V5H2C0.895431 5 0 5.89543 0 7V10C0 11.1046 0.895431 12 2 12H3V14C3 15.1046 3.89543 16 5 16H11C12.1046 16 13 15.1046 13 14V12H14C15.1046 12 16 11.1046 16 10V7C16 5.89543 15.1046 5 14 5H13V2C13 0.895431 12.1046 0 11 0H5C3.89543 0 3 0.89543 3 2ZM11 2H5V5H11V2ZM11 10H5V14H11V10Z",
    fill: "currentColor"
  })));
}

export default SvgPrint;